import {defineStore} from "pinia/dist/pinia";
import AppService from "@/service/AppService";
import {useLoadingStore} from "@/store/loadingStore";

export const useApplicationStore = defineStore('ApplicationStore', {
    state() {
        return {
            appService: new AppService(),
            baseCookiesState: localStorage.baseCookies === 'true',
            analyticsCookiesState: localStorage.analyticsCookies === 'true',
            marketingCookiesState: localStorage.marketingCookies === 'true',
            callBackUrlState: null,
            mailPreferencesState: null,
            areasOfInterestState: null,
            optOutReasonsState: [],
            formDataState: {},
            roleScannerState: "MPC_SCN"
        }
    },
    getters: {
        baseCookies() {
            return this.baseCookiesState
        },
        analyticsCookies() {
            return this.analyticsCookiesState
        },
        marketingCookies() {
            return this.marketingCookiesState
        },
        formData() {
            return this.formDataState
        },
        mailPreferences() {
            return this.mailPreferencesState
        },
        areasOfInterest() {
            return this.areasOfInterestState
        },
        optOutReasons() {
            return this.optOutReasonsState
        },
        roleScanner() {
            return this.roleScannerState
        }
    },
    actions: {
        setBaseCookies(baseCookies) {
            this.baseCookiesState = baseCookies;
            localStorage.baseCookies = baseCookies;
        },
        setAnalyticsCookies(analyticsCookies) {
            this.analyticsCookiesState = analyticsCookies;
            localStorage.analyticsCookies = analyticsCookies;
        },
        setMarketingCookies(marketingCookies) {
            this.marketingCookiesState = marketingCookies;
            localStorage.marketingCookies = marketingCookies;
        },
        setMailPreferences(mailPreferences) {
            this.mailPreferencesState = mailPreferences
        },
        setAreasOfInterest(areasOfInterest) {
            this.areasOfInterestState = areasOfInterest
        },
        setOptOutReasons(optOutReasons) {
            this.optOutReasonsState = optOutReasons
        },
        setFormData(formData) {
            this.formDataState = formData
        },
        initMailPreferences(contactId) {
            if (contactId != null) {
                this.loadingStore = useLoadingStore()
                this.loadingStore.startLoading();
                this.appService.mailPreferences(contactId).then(mailPreferences => {
                    for (const field in mailPreferences) {
                        mailPreferences[field] = mailPreferences[field] != null ? mailPreferences[field] : false
                        if(mailPreferences[field])
                            mailPreferences['emailPixel'] = true
                    }
                    this.setMailPreferences(mailPreferences)
                    this.loadingStore.stopLoading();
                }).catch(e => {
                    console.log(e)
                    this.loadingStore.resetLoading()
                })
            }
        },
        async initAreasOfInterest(contactId) {
            if (contactId != null) {
                this.loadingStore = useLoadingStore()
                this.loadingStore.startLoading();
                try {
                    const areasOfInterest = await this.appService.areasOfInterest(contactId)
                    this.setAreasOfInterest(areasOfInterest)
                    this.loadingStore.stopLoading();
                } catch (e) {
                    console.log(e)
                    this.loadingStore.resetLoading()
                }

            }
        },
        initOptOutReasons() {
            this.setOptOutReasons([
                {id: "I no longer want to receive these emails", label: "I no longer want to receive these emails"},
                {id: "The emails are too frequent", label: "The emails are too frequent"},
                {id: "I never signed up for these emails", label: "I never signed up for these emails"},
                {id: "Not relevant", label: "Not relevant"},
                {id: "I changed my job/workplace/retired", label: "I changed my job/workplace/retired"}
            ])
        },
        subscriberKeyByEsmoId(esmoId) {
            return this.appService.subscriberKeyByEsmoId(String(esmoId));
        },
        subscriberKeyByEsmoIdAndLastName(esmoId, lastName) {
            return this.appService.subscriberKeyByEsmoIdAndLastName(String(esmoId), String(lastName));
        },
        saveMailPreferences(mailPreferences, jobId, recordTypeID, utmSource, utmMedium, utmCampaign, optOutReason) {
            return this.appService.saveMailPreferences(mailPreferences, jobId, recordTypeID, utmSource, utmMedium, utmCampaign, optOutReason);
        },
        saveAreasOfInterest(areasOfInterest) {
            return this.appService.saveAreasOfInterest(areasOfInterest);
        },
        unsubscribe(subscriberKey, emailAddress, jobId, recordTypeID, utmSource, utmMedium, utmCampaign, optOutReason) {
            return this.appService.unsubscribe(subscriberKey, emailAddress, jobId, recordTypeID, utmSource, utmMedium, utmCampaign, optOutReason);
        }


    },
    persist: {
        storage: sessionStorage
    }
})
